(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nami-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nami-gallery')) {
 customElements.define('nami-gallery', class extends HTMLElement {
  connectedCallback() {
   if(this.bound) return; this.bound=true;
   const track=this.querySelector('.nami-gallery__track');
   const slides=[...this.querySelectorAll('.nami-gallery__slide')];
   const buttons=[...this.querySelectorAll('.nami-gallery__thumb')];
   const select=i=>buttons.forEach((b,n)=>b.setAttribute('aria-current',n===i?'true':'false'));
   buttons.forEach((button,i)=>button.addEventListener('click',()=>{track.scrollTo({left:slides[i].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});select(i)}));
   track.addEventListener('scroll',()=>select(Math.round(track.scrollLeft / Math.max(track.clientWidth,1))),{passive:true});
   select(0);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nami-replay-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.nl-product').forEach(root => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const track = root.querySelector('.nl-product__slides');
    const slides = [...root.querySelectorAll('.nl-product__slide')];
    const thumbs = [...root.querySelectorAll('[data-gallery-button]')];
    thumbs.forEach((button, index) => button.addEventListener('click', () => {
      track && track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      thumbs.forEach((item, i) => item.setAttribute('aria-current', i === index ? 'true' : 'false'));
    }));
    const offers = [...root.querySelectorAll('.nl-offer')];
    const variant = root.querySelector('[data-variant-input]');
    const quantity = root.querySelector('[data-quantity-input]');
    offers.forEach(card => card.querySelector('input').addEventListener('change', event => {
      offers.forEach(item => item.classList.toggle('is-selected', item === card));
      if (variant && event.target.dataset.variant) variant.value = event.target.dataset.variant;
      if (quantity && event.target.dataset.quantity) quantity.value = event.target.dataset.quantity;
    }));
    const checked = root.querySelector('.nl-offer input:checked');
    if (variant && checked && checked.dataset.variant) variant.value = checked.dataset.variant;
    if (quantity && checked && checked.dataset.quantity) quantity.value = checked.dataset.quantity;

    const testimonialCarousel = root.querySelector('[data-testimonial-carousel]');
    const testimonialTrack = testimonialCarousel && testimonialCarousel.querySelector('.nl-testimonials');
    const testimonialSlides = testimonialCarousel ? [...testimonialCarousel.querySelectorAll('[data-testimonial-slide]')] : [];
    const testimonialDots = testimonialCarousel ? [...testimonialCarousel.querySelectorAll('[data-testimonial-dot]')] : [];
    if (testimonialTrack && testimonialSlides.length > 1) {
      let testimonialIndex = 0;
      let testimonialTimer;
      let testimonialScrollFrame;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const testimonialSpeed = Math.max(3000, Number(testimonialCarousel.dataset.speed) || 5000);
      const setActiveTestimonial = index => {
        testimonialIndex = (index + testimonialSlides.length) % testimonialSlides.length;
        testimonialDots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === testimonialIndex);
          if (dotIndex === testimonialIndex) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      };
      const showTestimonial = index => {
        const nextIndex = (index + testimonialSlides.length) % testimonialSlides.length;
        testimonialTrack.scrollTo({left: testimonialSlides[nextIndex].offsetLeft - testimonialSlides[0].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth'});
        setActiveTestimonial(nextIndex);
      };
      const stopTestimonials = () => window.clearInterval(testimonialTimer);
      const startTestimonials = () => {
        stopTestimonials();
        if (!reducedMotion) testimonialTimer = window.setInterval(() => showTestimonial(testimonialIndex + 1), testimonialSpeed);
      };
      testimonialDots.forEach((dot, index) => dot.addEventListener('click', () => { showTestimonial(index); startTestimonials(); }));
      testimonialTrack.addEventListener('scroll', () => {
        window.cancelAnimationFrame(testimonialScrollFrame);
        testimonialScrollFrame = window.requestAnimationFrame(() => {
          const nextIndex = Math.round(testimonialTrack.scrollLeft / Math.max(1, testimonialTrack.clientWidth));
          setActiveTestimonial(nextIndex);
        });
      }, {passive:true});
      testimonialCarousel.addEventListener('mouseenter', stopTestimonials);
      testimonialCarousel.addEventListener('mouseleave', startTestimonials);
      testimonialCarousel.addEventListener('focusin', stopTestimonials);
      testimonialCarousel.addEventListener('focusout', startTestimonials);
      testimonialCarousel.addEventListener('touchstart', stopTestimonials, {passive:true});
      testimonialCarousel.addEventListener('touchend', startTestimonials, {passive:true});
      startTestimonials();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nami-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-review-more]').forEach(button => { if(button.dataset.ready) return; button.dataset.ready='true'; button.addEventListener('click',()=>{const root=button.closest('.nl-reviews');const open=root.classList.toggle('is-open');button.textContent=open?button.dataset.closeLabel:button.dataset.openLabel;button.setAttribute('aria-expanded',String(open));});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nami-sale-bars"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.nl-sale-bars').forEach(bars => {
    if (bars.dataset.ready === 'true') return;
    bars.dataset.ready = 'true';

    const hoursOutput = bars.querySelector('[data-clock-hours]');
    const minutesOutput = bars.querySelector('[data-clock-minutes]');
    const secondsOutput = bars.querySelector('[data-clock-seconds]');
    const clock = bars.querySelector('.nl-sale-bars__clock');
    const durationHours = Math.max(1, Number(bars.dataset.durationHours) || 16);
    const storageKey = `nami-loop-offer-deadline-${bars.dataset.sectionId}`;
    let deadline = Number(localStorage.getItem(storageKey));

    if (!Number.isFinite(deadline) || deadline <= Date.now()) {
      deadline = Date.now() + durationHours * 60 * 60 * 1000;
      localStorage.setItem(storageKey, String(deadline));
    }

    const render = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + durationHours * 60 * 60 * 1000;
        localStorage.setItem(storageKey, String(deadline));
      }

      const remaining = Math.max(0, deadline - now);
      const total = Math.floor(remaining / 1000);
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      hoursOutput.textContent = String(hours).padStart(2, '0');
      minutesOutput.textContent = String(minutes).padStart(2, '0');
      secondsOutput.textContent = String(seconds).padStart(2, '0');
      clock.setAttribute('aria-label', `${hours} horas, ${minutes} minutos y ${seconds} segundos`);
    };

    render();
    window.setInterval(render, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
